const state = {
  userFb: null,
  userStatus: 'unknown'
}

const actions = {

}

const mutations = {
  setUserFb (state, userFb) {
    state.userFb = userFb
  },
  setUserStatus (state, userStatus) {
    state.userStatus = userStatus
  }
}

const getters = {
  getUserFb (state) {
    return state.userFb
  },
  getUserStatus (state) {
    return state.userStatus
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
